export default __webpack_public_path__ + "static/media/ecommerce5.cf7b7041.png";